import React, { JSX } from 'react';
import { lzFInitials } from '@lz/services/String';
import LzMMedia from '../commons/Media';
import LzXMedia from '@lz/components/commons/Media';
import { LzTAlignments, LzNCrudMediaParams } from '@lz/typings/types';
import { LzNCrudField, LzTCrudFieldGroup } from './Field';

export type LzTCrudListingColumnGroup = {
  [key: string]: LzNCrudListingColumn;
};

export interface LzNCrudListingColumn {
  label?: string;
  icon?: JSX.Element;
  alignment?: LzTAlignments;
  sortable?: boolean;
  displayFunction?: (
    val: any,
    record?: any,
    params?: any,
    updateRecord?: (record: any, onlyLocal?: boolean) => void
  ) => any;
  mediaParams?: LzNCrudMediaParams;
  noWrap?: boolean;
  isMedia?: boolean;
}

class LzMCrudListingColumn implements LzNCrudListingColumn {
  label: string;
  icon?: JSX.Element;
  alignment: LzTAlignments;
  sortable: boolean;
  displayFunction: (
    val: any,
    record?: any,
    params?: any,
    updateRecord?: (record: any, onlyLocal?: boolean) => void
  ) => any;
  mediaParams?: LzNCrudMediaParams;
  noWrap: boolean;
  isMedia: boolean;

  constructor(model: LzNCrudListingColumn, field?: LzNCrudField) {
    this.label = model.label || '';
    this.icon = model.icon;
    this.alignment = model.alignment || 'center';
    this.sortable =
      typeof model.sortable === 'boolean' ? model.sortable : false;
    this.displayFunction = LzMCrudListingColumn.getDisplayFunction(
      model,
      field
    );
    this.mediaParams = model.mediaParams;
    this.noWrap = !!model.noWrap;
    this.isMedia = !!model.mediaParams; // save as a class var instead of making a getter because later this.mediaParams could be initialized to something and then it will not remain null
  }

  static getDisplayFunction(model: LzNCrudListingColumn, field?: LzNCrudField) {
    if (model && model.displayFunction) {
      return model.displayFunction;
    }

    if (
      field?.type === 'reference' &&
      typeof field?.refAppendedDisplayField === 'string' &&
      field.refAppendedDisplayField !== ''
    ) {
      return (val: any, record?: any) =>
        typeof field.refAppendedDisplayField === 'string' &&
        record[field?.refAppendedDisplayField]
          ? record[field.refAppendedDisplayField]
          : val === 0
          ? ''
          : val;
    }

    if (field?.type === 'media') {
      return (val: LzMMedia, record?: any) => {
        const altField = model.mediaParams?.altFieldName || '';
        const altValue = '' === altField ? '' : record[altField] || '';
        const initials = '' === altValue ? '' : lzFInitials(altValue);

        return (
          <LzXMedia
            isAvatar={!!model.mediaParams?.isAvatar}
            avatarSize={model.mediaParams?.avatarSize || 'small'}
            avatarInitials={initials}
            altText={altValue}
            imgSrc={val ? val.file_preview_path : ''}
            className='lz-card-media-small'
          />
        );
      };
    }

    return (val: any) => val;
  }

  static parseData(
    data: any,
    fields: LzTCrudFieldGroup
  ): LzTCrudListingColumnGroup {
    const out: LzTCrudListingColumnGroup = {};

    if (!data) {
      return out;
    }

    const keys = Object.keys(data);
    for (const key of keys) {
      out[key] = new LzMCrudListingColumn(
        data[key],
        fields ? fields[key] : undefined
      );
    }

    return out;
  }
}

export default LzMCrudListingColumn;
